import { ICard } from '@models/ICard';
import { IMeta } from '@models/IMeta';
import Card from '@molecules/Card/Card';
import NavigationCarousel from '@molecules/NavigationCarousel/NavigationCarousel';
import slugify from '@utils/helpers/slugify';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly title?: string;
  readonly list?: ICard[];
  readonly meta?: IMeta;
}

const CardCarousel = ({ title = '', list = [], meta }: Props) => (
  <section
    className="component-padding overflow-hidden bg-white text-black-100 dark:bg-black-100 dark:text-white"
    data-testid="CT-59-Card-Carousel"
  >
    <NavigationCarousel
      id={`card-carousel-${meta?.contentLink ?? ''}`}
      items={list}
      title={title}
      titleClassName="h4"
    >
      {(itemsToDisplay) =>
        itemsToDisplay?.map((card, index) => (
          <SwiperSlide
            className="stretch-card h-auto"
            key={slugify(`${card.title}-${index}`)}
            data-testid="CT-59-Card-Carousel-Item"
          >
            <Card {...card} carouselTitle={title} />
          </SwiperSlide>
        ))
      }
    </NavigationCarousel>
  </section>
);

export default CardCarousel;
